import React, { useState } from "react";
import Button from "../../assets/buttons/btnPrimary"
import ImgBanner from "./image/1440_hero.png"
import {Link} from "react-router-dom"
import "./banner.css";

const Banner = () => {
  
  return (
    <>
      <div className="bannerContainer">
        <div className="bannerImgContainer">
            <img src={ImgBanner} alt="" className="ImgChn"/>
        </div>
       <div className="bannerColumn">
       <div className="bannerTextContainer">
            <p className="bannerText">促进您的业务</p>
            <h1 className="bannerTitle">丁老师阿根廷财税咨询公司</h1>
            <p className="bannerTextTwo">咨询结合本地经验和国际网络，确保专业</p>
        </div>
        <Link to="mailto:bocabeijing@qq.com"> <Button styleClass="btnPrimary" value="CONTACT US"/></Link>
       </div>

      </div>
    </>
  );
};

export default Banner;
